// Determine the base URL at runtime to work in dev and prod.
// Prefer explicit env var, then window.location.origin, and fallback to the known domain.
export const BASE_URL =
  (typeof process !== 'undefined' && process.env && process.env.REACT_APP_BASE_URL) ||
  (typeof window !== 'undefined' && window.location && window.location.origin) ||
  'https://gtechniq.com.br';

export function fullUrl(path) {
  if (!path) return BASE_URL;
  if (typeof path !== 'string') return BASE_URL;
  const lowered = path.toLowerCase();
  if (lowered.startsWith('http://') || lowered.startsWith('https://') || lowered.startsWith('mailto:') || lowered.startsWith('tel:')) {
    return path;
  }
  if (path.startsWith('/')) return `${BASE_URL}${path}`;
  if (path.startsWith('#')) return path; // preserve in-page anchors
  return `${BASE_URL}/${path}`;
}
